import { useNewPurchaseOrderCategoriesInfiniteQuery } from "./useNewPurchaseOrderCategoriesInfiniteQuery";

/** Category list for the product-picker filter — infinite scroll, flat `data` array. */
export function useNewPurchaseOrderCategoriesQuery({ merchantId, enabled = true }) {
  const result = useNewPurchaseOrderCategoriesInfiniteQuery({
    merchantId,
    enabled,
  });

  return {
    ...result.query,
    data: result.categories,
    categories: result.categories,
    loadMore: result.loadMore,
    hasMore: result.hasMore,
    isFetchingNextPage: result.isFetchingNextPage,
    isPending: result.isPending,
    error: result.error,
  };
}
